module.exports = __webpack_public_path__ + "img/logo.ea55090a.svg";